import React from "react";
import { styled } from "@glitz/react";
import { black, fontSize, fontWeight, red, spacing, Theme, Size } from "../../theme";
import { Attribute } from "../../types";
import Button from "./Button";

interface ButtonGroupProps {
  name: string;
  attribute: Attribute;
  selected: { [key: string]: string };
  onSelect: (name: string, value: string) => void;
  /** Om satt: false = alternativet finns inte (eller säljs inte) i matrisen givet övriga val. */
  isOptionAvailable?: (option: string) => boolean;
}

const ButtonGroup: React.FC<ButtonGroupProps> = ({
  name,
  attribute,
  selected,
  onSelect,
  isOptionAvailable,
}) => {
  return (
    <AttributeWrapper>
      <Label>{name && name}</Label>
      <ButtonWrapper>
        {attribute.options?.map((option, index) => {
          const available = isOptionAvailable
            ? isOptionAvailable(option)
            : true;
          return (
            <OptionSlot
              key={index}
              style={!available ? { opacity: 0.5 } : undefined}
            >
              {!available && <UnavailabilityStrike aria-hidden />}
              <Button
                type="button"
                disabled={!available}
                title={
                  !available
                    ? "Finns inte som köpbar variant i den här kombinationen"
                    : undefined
                }
                onClick={() => onSelect(name, option)}
                as={Theme.Positive}
                size={Size.Small}
                style={selected[name] === option ? isSelected : undefined}
              >
                {option}
              </Button>
            </OptionSlot>
          );
        })}
      </ButtonWrapper>
    </AttributeWrapper>
  );
};

const AttributeWrapper = styled.div({
  marginBottom: spacing.s,
});
const ButtonWrapper = styled.div({
  display: "flex",
  flexWrap: "wrap",
  gap: spacing.xs,
});

const OptionSlot = styled.div({
  position: "relative",
  display: "inline-flex",
  maxWidth: "100%",
  overflow: "hidden",
  borderRadius: "5px",
});

const UnavailabilityStrike = styled.div({
  position: "absolute",
  zIndex: 1,
  top: "50%",
  left: "50%",
  width: "150%",
  height: "2px",
  backgroundColor: red,
  transform: "translate(-50%, -50%) rotate(-32deg)",
  pointerEvents: "none",
});
const isSelected: React.CSSProperties = {
  backgroundColor: black,
  border: `2px solid ${black}`,
};

const Label = styled.label({
  fontSize: fontSize.s,
  color: black,
  fontWeight: fontWeight.bold,
  marginBottom: spacing.xxs,
  display: "block",
});

export default ButtonGroup;
